//====================================================
//  Function: Christmas countdown
//====================================================

var countdownDay;
var countdownHours;
var countdownMinutes;

function componentChristmasCountdown() {
  if ($(".top-navigation-tools").length) {
    var christmasCountdown = `
			<div class="christmas-countdown">
				<div class="christmas-countdown__left-panel">
					<div class="christmas-countdown__icon">
						<svg class="icon-svg icon-christmas-calendar">
							<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-christmas-calendar"></use>
						</svg>
					</div>
					<div class="christmas-countdown__title">${christmasCountDown}</div>
				</div>
				<div class="christmas-countdown__right-panel js-christmas-countdown">
					<div class="christmas-countdown__item">
						<div class="christmas-countdown__number js-christmas-countdown-days">00</div>
						<div class="christmas-countdown__text">${days}</div>
					</div>
					<div class="christmas-countdown__item">
						<div class="christmas-countdown__number js-christmas-countdown-hours">00</div>
						<div class="christmas-countdown__text">${hours}</div>
					</div>
					<div class="christmas-countdown__item">
						<div class="christmas-countdown__number js-christmas-countdown-minutes">00</div>
						<div class="christmas-countdown__text">${minutes}</div>
					</div>
				</div>
			</div>
		`;

    $(".top-navigation-tools").prepend(christmasCountdown);

    countdownDay = document.querySelector(".js-christmas-countdown-days");
    countdownHours = document.querySelector(".js-christmas-countdown-hours");
    countdownMinutes = document.querySelector(
      ".js-christmas-countdown-minutes"
    );

    setInterval(calcCountdown, 0);
  }
}

function calcCountdown() {
  today = new Date();

  xmas = new Date("December 24, " + today.getFullYear());

  if (today > xmas) {
    xmas.setYear(today.getFullYear() + 1);
  }

  msPerDay = 24 * 60 * 60 * 1000;
  timeLeft = xmas.getTime() - today.getTime();
  e_daysLeft = timeLeft / msPerDay;
  daysLeft = Math.floor(e_daysLeft);
  e_hrsLeft = (e_daysLeft - daysLeft) * 24;
  hrsLeft = Math.floor(e_hrsLeft);
  e_minsLeft = (e_hrsLeft - hrsLeft) * 60;
  minsLeft = Math.floor(e_minsLeft);

  countdownDay.innerHTML = makeMeTwoDigits(daysLeft);
  countdownHours.innerHTML = makeMeTwoDigits(hrsLeft);
  countdownMinutes.innerHTML = makeMeTwoDigits(minsLeft);
}

function makeMeTwoDigits(n) {
  return (n < 10 ? "0" : "") + n;
}
